import { makeTheme } from '@dmp/shared/components/make-theme/make-theme';
import Button from './components/themed-button';
import Checkbox from './components/themed-checkbox';
import Menu from './components/themed-menu';
import Popover from './components/themed-popover';

export const themeInfo = makeTheme({
    baseColors: {
        primary: '#1665cf',
        secondary: '#ff9100',
    },
    globalStyles: () => ({
        'html, #root': {
            width: '100%',
            height: '100%',
            overflow: 'hidden',
        },
        body: {
            width: '100%',
            height: '100%',
            background: 'gray.200',
            color: 'gray.700',
            _dark: { background: 'gray.800', color: 'gray.300' },
        },
        // Avoid the original slow animation. Snapiness is king. (*♡∀♡)
        '.chakra-menu__menu-list': {
            transform: 'none !important',
            transition: 'none !important',
            opacity: '1 !important',
        },
        '.chakra-popover__content': {
            transform: 'none !important',
            transition: 'none !important',
            opacity: '1 !important',
        },
    }),
    componentConfigs: {
        Button,
        Menu,
        Checkbox,
        Popover,
    },
});
